export default __webpack_public_path__ + "static/media/social-tiktok.a749053e.svg";